import { render, staticRenderFns } from "./CrudItem.vue?vue&type=template&id=f98bfc1a"
import script from "./CrudItem.vue?vue&type=script&lang=js"
export * from "./CrudItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports